import { ITEM_TYPE_FOLDER, ITEM_TYPE_FILE, ITEM_TYPE_WEBLINK } from './constants';

var bpfrpt_proptype_inlineNoticeType = PropTypes.oneOf(['warning', 'error', 'success', 'info']);
var bpfrpt_proptype_itemType = PropTypes.oneOfType([function () {
    return (typeof ITEM_TYPE_FOLDER === 'function' ? PropTypes.instanceOf(ITEM_TYPE_FOLDER) : PropTypes.any).apply(this, arguments);
}, function () {
    return (typeof ITEM_TYPE_FILE === 'function' ? PropTypes.instanceOf(ITEM_TYPE_FILE) : PropTypes.any).apply(this, arguments);
}, function () {
    return (typeof ITEM_TYPE_WEBLINK === 'function' ? PropTypes.instanceOf(ITEM_TYPE_WEBLINK) : PropTypes.any).apply(this, arguments);
}]);
import PropTypes from 'prop-types';
export { bpfrpt_proptype_inlineNoticeType };
export { bpfrpt_proptype_itemType };